import { 
    getUserBalance, 
    getTransactionHistory,
    submitProofData, 
    submitProofImage,
    storeUserBalance,
    storeTransaction,
    deductUserBalance,
    postTopUpDetails,
    getTopUpDetails
} from "../../requests"

export const getBalanceAmount = async (userId, token) =>{
    return await getUserBalance(userId,token)
}

export const getTransaction = async (userId, token) =>{
    return await getTransactionHistory(userId, token)
}

export const postSubmitProofData = async (userId, data, token) =>{
    return await submitProofData(userId, data, token)
}

export const putSubmitProofImage = async (userId, data) =>{
    return await submitProofImage(userId, data)
}

export const postUserBalance = async (userId, data, token) =>{
    return await storeUserBalance(userId, data, token)
}

export const putCashBackAmount = async (userId, data, token) =>{
    return await storeUserBalance(userId, data, token)
}

export const postTransaction = async (userId, data, token) =>{
    return await storeTransaction(userId, data, token)
}

export const deductionUserBalance = async (userId, data, token) =>{
    return await deductUserBalance(userId, data, token)
}

export const postopUpDetails = async (userId, data, token) =>{
    return await postTopUpDetails(userId, data, token)
}

export const getopUpDetails = async (userId, token) =>{
    return await getTopUpDetails(userId, token)
}
